import styled from "styled-components";

export const CommonCardWrapper = styled.div`
  position: relative;
  background: rgb(255, 255, 255);
  border-radius: 25px;
  padding: 35px 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: rgb(0 0 0 / 21%) 0px 0px 200px;
  backdrop-filter: blur(27.5px);
  height: 100%;
  cursor: pointer;
  transition: 0.4s ease-in-out;
  overflow: hidden;
  @media (max-width: 1199px) {
    border-radius: 20px;
  }
  @media (max-width: 599px) {
    border-radius: 15px;
    padding: 25px 15px;
  }
  @media (max-width: 599px) {
    border-radius: 12px;
  }
  &:hover {
    transform: scale(1.05);
  }

  figure {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .inner_text {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    .cardDetails {
      * {
        color: rgba(256, 256, 256, 1);
      }
    }
  }

  h3 {
    font-weight: 600;
    font-size: 20px;
    letter-spacing: -0.011em;
    margin-bottom: 30px;
  }
  p {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
  }
  .btn_wrap {
    margin-top: auto;
    padding-top: 30px;
    .card_button {
      min-width: auto;
      width: 100%;
      border-radius: 0;
      border: 1px solid rgb(255, 24, 24);
    }
  }
`;
